import { useTranslation } from 'react-i18next';
import { WarningIcon } from '../svg/WarningIcon';
import './styles.scss';

export const FiveHundred = () => {
	const { t } = useTranslation('Common');
	return (
		<div className="error-view">
			<h1 className="title">{t('Error 500, something went wrong')}</h1>
			<div>
				{t('You can always')} <a href="/">{t('go back home')}</a>
			</div>
			<div className="message">
				{t('Contact support to get help if you keep seeing this error.')}
			</div>
			<div className="image">
				<WarningIcon />
			</div>
		</div>
	);
};
